import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Messages from '../../components/common/Toastr/messages';
import EsqueciPwdForm from '../EsqueciPwd/Form';
import NovoPwdFrom from './Form';
import { getIPs } from '../../util/helper';
import { validaHash } from '../../actions/authActions';
import { useHistory } from 'react-router-dom';
const Page = ({
        className,
        bgColorContainer,
        redirectBack,
        hash,
        willCp = true,
        boxTitle = boxTitle || '',
        bgColorBoxTitle = bgColorBoxTitle || '',
        textColorBoxTitle = textColorBoxTitle || '#000000',
    }) => {
    const { cpfLoginValidated, sucesso, hashIsValid, validatingHash, hashChecked } = useSelector(({ authreducer }) => authreducer );

    const history = useHistory();
    const dispatch = useDispatch();

    const [ip, setIp] = useState({
        Private_IP: '0.0.0.0',
        Public_IP: '0.0.0.0',
      });

    useEffect(() => {
        dispatch(validaHash(hash));
        getIPs((ip_) => {
                if (ip_.match(/^(192\.168\.|169\.254\.|10\.|172\.(1[6-9]|2\d|3[01]))/)) {
                    setIp({...ip, Private_IP: ip_ })
                } else {
                    setIp({...ip, Public_IP: ip_ })
                }
            })
    }, []);

    useEffect(() => {
        if(!hashIsValid && !validatingHash && hashChecked) {
            sessionStorage.setItem('tokenExpired', true)
            history.push('#/');
        }
    },[validatingHash, hashIsValid])

    const goBack = () => {
        document.location.href = redirectBack || '#/';
    };

    if (sucesso) {
        setTimeout(() => {
            window.location.href = '#/';
        },3000)
        }

    return (
        <React.Fragment>
                {!cpfLoginValidated && (
                    <EsqueciPwdForm
                        Public_IP={ip.Public_IP}
                        Private_IP={ip.Private_IP}
                        title="Criação de Senha"
                        labels={{
                            login: "Digite seu usuário",
                            cpf: "Digite seu CPF/CNPJ",
                        }}
                        sendButtonText="Enviar"
                        className={className}
                        bgColorContainer={bgColorContainer}
                        onBack={goBack}
                        hash={hash}
                        willCp={willCp}
                        boxTitle={boxTitle}
                        bgColorBoxTitle={bgColorBoxTitle}
                        textColorBoxTitle={textColorBoxTitle}
                    />
                )}
                {!!cpfLoginValidated && (
                    <NovoPwdFrom
                        Public_IP={ip.Public_IP}
                        Private_IP={ip.Private_IP}
                        bgColorContainer={bgColorContainer}
                        redirectBack={redirectBack}
                        goBack={goBack}
                        hash={hash}
                        willCp={willCp}
                        boxTitle={boxTitle}
                        bgColorBoxTitle={bgColorBoxTitle}
                        textColorBoxTitle={textColorBoxTitle}
                    />
                )}
            <Messages />
        </React.Fragment>
    );
};

export default Page;
